import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { StyleLine } from '@wizeoo/akm-message-lib';
import { ViewData } from '../../model/view.data';
import { Model } from '../../model/model';
import { FakeVO } from '../common/tool/fake.vo';
import { IVo, entity, field } from '@wizeoo/akm-compute-lib';

/**
 * condition d'un style
 */
@entity('wizeoo.allkeyme.workingdata.message.StyleLine', 'VISION')
export class StyleLineVO implements IVo {

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }
  public set model(value: Model) {
      this._model = value;
  }
  
  constructor(model: Model, pSource?: StyleLine) {
    this._model = model;
    this._source = null;
    if (pSource) {
      this._source = pSource;
    } else {
      this._source = new StyleLine();
      this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
    }
  }

  /** L'objet source provenant du back */
  private _source: StyleLine;
  public get source(): StyleLine {
    return this._source;
  }
  public set source(value: StyleLine) {
    this._source = value;
  }

  // code domaine (root), technique
  public get domain(): string {
    return this._source.domain;
  }
  public set domain(value: string) {
    this._source.domain = value;
  }

  public get businessUnitCode(): string {
    // code de la BU
    return this._source.businessUnitCode;
  }
  public set businessUnitCode(value: string) {
    this._source.businessUnitCode = value;
  }

  /**
   * code du style parent
   */
  public set key(value: string) {
    this._source.key = value;
  }
  public get key(): string {
    return this._source.key;
  }

  public set kind(value: string) {
    this._source.kind = value;
  }
  public get kind(): string {
    return this._source.kind;
  }

  public set renderer(value: string) {
    this._source.renderer = value;
  }
  public get renderer(): string {
    return this._source.renderer;
  }

  // Id technique
  public get id(): number {
    return this._source.id;
  }
  public set id(value: number) {
    this._source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this._source.uid;
  }
  public set uid(value: string) {
    this._source.uid = value;
  }

  public get version(): number {
    // technique
    return this._source.version;
  }
  public set version(value: number) {
    this._source.version = value;
  }

  /** position de la condition dans la pile (et clé d'enregistrement dans la map) */
  @field('number')
  public get order(): number {
    return this._source.order;
  }
  public set order(value: number) {
    this._source.order = value;
  }

  /** formule */
  @field('string')
  public set formula(value: string) {
    this._source.formula = value;
  }
  public get formula(): string {
    return this._source.formula;
  }

  /** comparateur */
  @field('string')
  public set comparator(value: string) {
    this._source.comparator = value;
  }
  public get comparator(): string {
    return this._source.comparator;
  }

  /** css */
  @field('string')
  public set css(value: string) {
    this._source.css = value;
    this._cssAsObject = null; // reset du css en objet
  }
  public get css(): string {
    return this._source.css;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** accès au fakeVO du comparateur */
  public get comparatorVO(): FakeVO {
    return ViewData.getInstance().comparatorMap.get(this.comparator);
  }

  /** La condition est-elle persistée ? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this._source.id > 0;
  }

  private _cssAsObject: any = null;
  public get cssAsObject(): any {
    if (!this._cssAsObject) {
      this._cssAsObject = this.model.styleEngine.stringToCss(this.css);
    }
    return this._cssAsObject;
  }
}
